import React, { useState } from 'react';
import styles from "./TopSection.module.css";
import Progress from '../Progressbar/Progress';
import DiwaliImg from "../../../../assets/Diwali_LandingPage/TopImage/Diwali.svg";
import BookingModal from './BookingModal';

const TopSection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.left}>
                    <p>Your Finances need cleaning too!</p>
                    <span>Get a FREE 1-on-1 review of your money from professionals</span>
                    <div className={styles.freecall}>
                        <button className={styles.btn} onClick={handleOpenModal}>
                            Book A Free Review Now
                        </button>
                        <Progress />
                    </div>
                </div>
                <div className={styles.Diwali_Img}>
                    <img src={DiwaliImg} alt='Diwali_Img' />
                </div>
            </div>
            {isModalOpen && <BookingModal onClose={handleCloseModal} />}
        </div>
    );
}

export default TopSection;
